import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

export default function SchedulerSkeleton({ count = 2 }) {
  return (
    <Grid container spacing={2}>
      {Array.from({ length: count }, (_, index) => (
        <Grid key={index} size={{ xs: 12, sm: 6 }}>
          <Box
            py={1}
            px={2}
            border={1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            borderColor="divider"
            borderRadius={1}
          >
            <Box display="flex" flexDirection="column" width="70%">
              <Skeleton variant="text" width="80%" height={20} />
              <Skeleton variant="text" width="60%" height={16} />
            </Box>
            <Box display="flex">
              <Skeleton variant="circular" width={32} height={32} sx={{ mr: 0.5 }} />
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
